// extracted by mini-css-extract-plugin
export default {"desc":"DetailsDocuments_desc__MsXDK","item":"DetailsDocuments_item__kah3w"};